import { MenuItem } from '../models/menu.model';

export const MENU_ITEMS: MenuItem[] = [
  { label: 'Dashboard', icon: 'pi pi-home', path: '/dashboard' },
];
